module.exports = __webpack_public_path__ + "img/glow-yellow-small.be6af94b.png";